
import SyncPdvDesktopService from "../services/SyncPdvDesktopService";
import TerminalConfigService from "../services/TerminalConfigService";
import { SYSTEM_VARIABLE } from "@/modules/Application";

export default {
  name: "PdvTerminalSetup",

  data() {
    return {
      passo: 1,
      form: { uuid_terminal: "" },
      terminalDados: {},
      erros: {},
      erroGeral: null,
      validando: false,
      carregando: false,
      sincronizando: false,
      sucesso: false,
      progresso: 0,
      statusSync: "",
    };
  },

  async mounted() {
    if (!this.$isDesktop) {
      this.$router.push({ name: "pdvDesktopLogin" });
      return;
    }
    // Pré-preenche UUID se já tiver um salvo
    try {
      const info = await this.$electron.terminal.getInfo();
      if (info && info.uuid_terminal) {
        this.form.uuid_terminal = info.uuid_terminal;
      }
    } catch (_) { /* ignore */ }
  },

  methods: {
    async validarTerminal() {
      this.erros = {};
      this.erroGeral = null;

      if (!this.form.uuid_terminal.trim()) {
        this.erros.uuid_terminal = "O identificador do terminal é obrigatório.";
        return;
      }

      this.validando = true;
      try {
        const apiUrl = (SYSTEM_VARIABLE.BASE_URL_API || "").replace(/\/$/, "");
        if (!apiUrl) throw new Error("URL da API não configurada.");

        const token = await this.$electron.config.get("api_token");
        if (!token) throw new Error("Token não encontrado. Faça login novamente.");

        // Obtém identificação única e permanente deste dispositivo
        const [device_id, device_name] = await Promise.all([
          this.$electron.device.getDeviceId(),
          this.$electron.device.getDeviceName(),
        ]);

        const resp = await fetch(
          `${apiUrl}/api/offline/terminal/${encodeURIComponent(this.form.uuid_terminal.trim())}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ device_id, device_name }),
          }
        );

        if (!resp.ok) {
          let errJson = {};
          try { errJson = await resp.json(); } catch (_) { /* ignore */ }

          if (resp.status === 409) {
            // Terminal já vinculado a outro dispositivo
            throw new Error(
              errJson.message ||
              "Este terminal já está vinculado a outro computador. Para usar neste dispositivo, desvincule o terminal no painel web."
            );
          }
          if (resp.status === 403) {
            throw new Error(errJson.message || "Terminal bloqueado ou inativo. Verifique no painel web.");
          }
          if (resp.status === 404) {
            throw new Error("Terminal não encontrado. Verifique o identificador.");
          }
          throw new Error(errJson.message || `Erro ao validar terminal (HTTP ${resp.status}).`);
        }

        const json = await resp.json();

        // API retornou status false (ex: uuid inválido, terminal não encontrado)
        if (json.status === false || json.status === 0) {
          throw new Error("Terminal não localizado. Verifique o identificador e tente novamente.");
        }

        // Aceita { terminal, configuracao }, { data: ... } ou resposta direta
        const dados    = json.data ?? json;
        const terminal = dados.terminal    ?? dados;
        const config   = dados.configuracao ?? {};
        const nfce     = dados.configuracao_nfce ?? dados.nfce_config ?? null;
        const idConfiguracaoNfce =
          nfce?.id_configuracao ??
          nfce?.id ??
          config.id ??
          dados.id_configuracao ??
          null;


        this.terminalDados = {
          id_terminal_venda: terminal.id_terminal_venda ?? terminal.id ?? null,
          uuid_terminal:     terminal.uuid_terminal ?? terminal.uuid ?? this.form.uuid_terminal.trim(),
          nome:              terminal.nome ?? terminal.name ?? this.form.uuid_terminal.trim(),
          id_configuracao:   idConfiguracaoNfce,
          serie:             nfce?.serie ?? config.serie ?? dados.serie ?? dados.serie_nfe ?? "",
          proxima_venda:     nfce?.proximaVenda ?? nfce?.proxima_venda ?? config.proximaVenda ?? config.proxima_venda ?? dados.proxima_venda ?? dados.proximo_numero ?? 1,
          id_empresa:        terminal.id_empresa ?? dados.id_empresa ?? null,
          configuracao_nfce: nfce,
        };

        this.passo = 2;
      } catch (e) {
        this.erroGeral = e.message || String(e);
      } finally {
        this.validando = false;
      }
    },

    async confirmarESincronizar() {
      this.erroGeral = null;
      this.carregando = true;
      this.sincronizando = false;
      this.progresso = 0;
      this.statusSync = "";

      try {
        const apiUrl = (SYSTEM_VARIABLE.BASE_URL_API || "").replace(/\/$/, "");
        const token = await this.$electron.config.get("api_token");

        // Persiste todos os dados do terminal
        await this.$electron.terminal.save({
          uuid_terminal:    this.terminalDados.uuid_terminal,
          serie:            this.terminalDados.serie,
          nome:             this.terminalDados.nome,
          id_terminal_venda: this.terminalDados.id_terminal_venda,
          id_configuracao:  this.terminalDados.id_configuracao,
          proxima_venda:    this.terminalDados.proxima_venda,
          id_empresa:       this.terminalDados.id_empresa,
          config:           { api_url: apiUrl },
        });
        await this.$electron.config.set("api_url", apiUrl);
        if (this.terminalDados.configuracao_nfce) {
          await TerminalConfigService.salvarConfiguracaoNfceTerminal(
            this.terminalDados.configuracao_nfce
          );
        } else {
          await TerminalConfigService.limparConfiguracaoNfceTerminal();
        }

        this.sincronizando = true;

        await SyncPdvDesktopService.sincronizarCompleto({
          onProgress: (pct, status) => {
            this.progresso = pct;
            this.statusSync = status;
          },
        });

        this.sincronizando = false;
        this.sucesso = true;

        setTimeout(() => {
          this.$router.push({ name: "pdvDesktopDashboard" });
        }, 1200);
      } catch (e) {
        this.sucesso = false;
        this.sincronizando = false;
        this.erroGeral = `Erro: ${e.message || String(e)}`;
        console.error("[TerminalSetup] confirmarESincronizar:", e);
      } finally {
        this.carregando = false;
      }
    },
  },
};
